import React from 'react'
import TopBar from '../Home/Mainhomeone/Topbar'
import Header from '../Globle/Header1'
import Navigation from '../Home/Mainhomeone/Navigation'
import Breadcrumb from '../Globle/Breadecrumb'
import TeamDetails from '../MainTeamDetails/TeamDetails'
import Footer1 from '../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Breadcrumb title=' Team Detail' />
            <TeamDetails />
            <Footer1 />
        </>
    )
}

export default Main
